import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_translation from './lang_transilation/en_transilation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en_translation,
      },
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
